import React from 'react'

const EmployeeModuleHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_3153_50724)" />
    <path
      d="M28.944 49.5001C25.4216 49.5001 21.9534 49.5001 18.431 49.5001C16.7511 49.5001 16.155 48.7414 16.426 47.1699C17.4556 41.3173 22.4953 36.9279 28.3479 36.7112C34.5256 36.4944 39.9988 40.5587 41.4078 46.357C42.0039 48.7414 41.4078 49.5001 38.9692 49.5001C35.6094 49.5001 32.3038 49.5001 28.944 49.5001Z"
      fill="white"
    />
    <path
      d="M28.9979 20.5081C32.7912 20.5081 35.8259 23.4885 35.8259 27.2277C35.8259 30.8584 32.6287 34.0015 28.9437 34.0015C25.2588 34.0015 22.1699 30.8584 22.1699 27.1735C22.1699 23.4343 25.1504 20.5081 28.9979 20.5081Z"
      fill="white"
    />
    <path
      opacity="0.6"
      d="M40.8657 20.5081C43.792 20.5081 46.1764 22.188 47.2602 24.8434C48.344 27.6071 47.6395 30.5875 45.4719 32.4842C43.521 34.2183 40.378 34.6518 38.102 33.5138C37.2891 33.0803 36.7472 32.8635 37.6685 31.8339C39.9445 29.287 39.9445 25.7104 37.7227 23.1093C36.8014 22.0255 37.1266 21.6461 38.1562 21.1584C39.0774 20.6707 40.0528 20.4539 40.8657 20.5081Z"
      fill="white"
    />
    <path
      opacity="0.6"
      d="M44.6053 49.2291C45.4723 48.0911 45.1472 47.0614 44.8762 45.9776C43.9008 42.5636 41.8416 39.9625 38.7527 38.1742C38.3192 37.9033 37.7231 37.8491 37.4521 37.3072C44.4427 34.9228 52.6255 40.0167 53.6009 47.224C53.7635 48.4162 53.3841 49.1749 52.0836 49.1749C49.5908 49.2291 47.2064 49.2291 44.6053 49.2291Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3153_50724"
        x1="35"
        y1="0"
        x2="35"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0B62B5" />
        <stop offset="1" stop-color="#003F7C" />
      </linearGradient>
    </defs>
  </svg>
)

export default EmployeeModuleHome
